module.exports = __webpack_public_path__ + "img/promsviaz.18e54e4f.svg";